module.exports = require("./es-ES");